// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__TUPsz"};